import { HpValidationResult } from '@avantia/form-validation';
import { lodash } from '@avantia/lodash';
import { createQuestionPanelId } from '@avantia/questionset-model';
import jQuery from 'jquery';
import { ReactElement } from 'react';

interface ValidationSummaryWidgetProps {
  location: Location;
  validationResult: HpValidationResult;
}

export function ValidationSummaryWidget({
  validationResult,
  location
}: ValidationSummaryWidgetProps): ReactElement | null {
  const errors: ReactElement[] = [];
  const onClickFunc = (qid: string) => () => focusOnElement(qid);
  const { pathname } = location;
  lodash.forOwn(validationResult.errors, (message, questionId) => {
    if (message) {
      const qid = createQuestionPanelId(questionId);

      errors.push(
        <li key={questionId}>
          <a
            id={`ERR${questionId}`}
            href={`${pathname}#${qid}`}
            onClick={onClickFunc(qid)}
            onKeyPress={onClickFunc(qid)}
          >
            {message}
          </a>
        </li>
      );
    }
  });

  if (errors.length === 0) {
    return null;
  }

  return (
    <div className="av-card av-card-child av-card-error-summary">
      <h3>You haven&lsquo;t answered all the questions</h3>
      <ul>{errors}</ul>
    </div>
  );
}

function focusOnElement(id: string): void {
  const $ = jQuery;
  setTimeout(() => {
    const el = document.getElementById(id);
    if (el) {
      const list = $('.av-field-section button, .av-field-section input', el).toArray();
      const item = list.filter((item) => $(item).is(':visible'))[0];
      if (item) {
        if (item.tagName === 'INPUT' && (item as HTMLInputElement).type === 'radio') {
          return;
        }

        if (item) {
          try {
            item.focus();
          } catch {
            return;
          }
        }
      }
    }
  }, 25);
}
